import Handlebars from 'handlebars';

import ModalTemplate from 'templates/modals/stockists/modal.html';
import StorePickerTemplate from 'templates/modals/stockists/store-picker.html';
import storeDB from 'data/stockists.json';


export default class Stockists {
    constructor (triggerElement, items) {
        this.triggerElement = triggerElement;

        this.settings = {
            country: '',
            city: '',
        }

        this.bindTriggerEvents();
    }

    bindTriggerEvents () {
        this.triggerElement.addEventListener('click', this.openModal.bind(this), false);
    }

    openModal (e) {
        e.preventDefault();

        const rendered = Handlebars.compile(ModalTemplate)();
        document.body.insertAdjacentHTML('beforeend', rendered);
        this.element = document.querySelector('.js-modal');
        this.storePickerEl = this.element.querySelector('.js-store-picker');

        document.documentElement.classList.add('is-inactive');

        this.refreshList();
        this.bindModalEvents();
    }

    render () {
        const rendered = Handlebars.compile(StorePickerTemplate)(this.generateContext());

        this.storePickerEl.innerHTML = rendered;
    }

    generateContext () {
        return {
            countries: this.setCountries(),
            cities: this.setCities(),
            stores: this.setStores(),
            cityClass: this.settings.country !== '' ? 'is-active' : '',
            storeClass: this.settings.city !== '' ? 'is-active' : '',
        }
    }

    setCountries () {
        let countries = [];

        storeDB.countries.forEach((country) => {
            if (country.slug === this.settings.country) {
                country.class = 'is-active';
            } else {
                country.class = '';
            }

            countries.push(country);
        });

        return countries;
    }

    setCities () {
        let country = storeDB.countries.filter((country) => {
            if (country.slug === this.settings.country) {
                return true;
            }
        });

        if (country[0]) {
            this.country = country[0];
        }

        let cities = (country[0] && country[0].cities) || [];

        cities.forEach((city, index) => {
            if (city.slug === this.settings.city) {
                cities[index].class = 'is-active';
            } else {
                cities[index].class = '';
            }
        });

        return cities;
    }

    setStores () {
        if (!this.country) {
            return [];
        }

        let city = this.country.cities.filter((city) => {
            if (city.slug === this.settings.city) {
                return true;
            }
        });

        return (city[0] && city[0].stores) || [];
    }

    bindModalEvents () {
        Array.from(this.element.querySelectorAll('.js-close')).forEach((closeEl) => {
            closeEl.addEventListener('click', this.closeModal.bind(this));
        });
    }

    bindStoreListEvents () {
        Array.from(this.storePickerEl.querySelectorAll('.js-country')).forEach((el) => {
            el.addEventListener('click', this.setCountry.bind(this));
        });

        Array.from(this.storePickerEl.querySelectorAll('.js-city')).forEach((el) => {
            el.addEventListener('click', this.setCity.bind(this));
        });

        Array.from(this.storePickerEl.querySelectorAll('.js-back-btn')).forEach((el) => {
            el.addEventListener('click', this.goBack.bind(this));
        });
    }

    refreshList () {
        this.render();
        this.bindStoreListEvents();
    }

    setCity (e) {
        e.preventDefault();

        this.settings.city = e.currentTarget.dataset.city;

        this.refreshList();
    }

    setCountry (e) {
        e.preventDefault();

        this.settings.city = '';
        this.settings.country = e.currentTarget.dataset.country;

        this.refreshList();
    }

    goBack (e) {
        e.preventDefault();

        e.target.parentNode.classList.remove('is-active');
    }

    closeModal () {
        this.element.parentNode.removeChild(this.element);

        document.documentElement.classList.remove('is-inactive');
    }
}



// WEBPACK FOOTER //
// ./lib/stockists.js